import BaseSnackbar from './BaseSnackbar.vue';

export { BaseSnackbar };
